import { IAppState } from '../../common/state';
import { roomTypeMap } from '../../constants/roomType';
import { getResultsRoomType } from '../getResultsRoomType';

export function getNewbuildingRoomTypeSeoTitle(state: IAppState) {
  const roomType = getResultsRoomType(state);

  return `Купить ${roomType.length === 1 ? roomTypeMap[roomType[0]] : 'квартиру'} в\u00A0`;
}
